import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
} from "@mui/material";
import { ThemeContext } from "../utils/ThemeContext";

const COLORS = [
  "#4F46E5", // Indigo
  "#7C3AED", // Purple
  "#DB2777", // Pink
  "#F43F5E", // Red
  "#F97316", // Orange
  "#F59E0B", // Amber
  "#10B981", // Emerald
  "#0D9488", // Teal
  "#06B6D4", // Cyan
  "#3B82F6", // Blue
];

const ThemeSettings = () => {
  const { theme, updateTheme } = useContext(ThemeContext);

  const defaultTheme = {
    sidebarColor: "#2c3e50",
    appBarColor: "#007bff",
  };

  const [selectedSidebar, setSelectedSidebar] = useState(defaultTheme.sidebarColor);
  const [selectedAppbar, setSelectedAppbar] = useState(defaultTheme.appBarColor);

  useEffect(() => {
    const storedTheme = localStorage.getItem("customTheme");
    if (storedTheme) {
      const parsed = JSON.parse(storedTheme);
      setSelectedSidebar(parsed.sidebarColor);
      setSelectedAppbar(parsed.appBarColor);
      updateTheme(parsed);
    }
  }, []);

  const handleSidebarColor = (color) => {
    setSelectedSidebar(color);
    const newTheme = { ...theme, sidebarColor: color };
    updateTheme(newTheme);
    localStorage.setItem("customTheme", JSON.stringify(newTheme));
  };

  const handleAppbarColor = (color) => {
    setSelectedAppbar(color);
    const newTheme = { ...theme, appBarColor: color };
    updateTheme(newTheme);
    localStorage.setItem("customTheme", JSON.stringify(newTheme));
  };

  const handleReset = () => {
    setSelectedSidebar(defaultTheme.sidebarColor);
    setSelectedAppbar(defaultTheme.appBarColor);
    updateTheme(defaultTheme);
    localStorage.removeItem("customTheme");
  };

  const ColorBlock = ({ color, selected, onClick }) => (
    <Box
      onClick={onClick}
      sx={{
        width: 32,
        height: 32,
        borderRadius: "6px",
        backgroundColor: color,
        cursor: "pointer",
        border: selected ? "3px solid #000" : "2px solid transparent",
        boxShadow: selected ? "0 0 0 2px white" : "none",
        transition: "all 0.2s ease",
      }}
    />
  );

  return (
    <Box sx={{ padding: 4, maxWidth: "600px", margin: "auto" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Theme Settings
      </Typography>

      <Paper elevation={3} sx={{ padding: 3, mt: 2 }}>
        <Typography variant="h6" gutterBottom>
          Sidebar Color
        </Typography>
        <Grid container spacing={1}>
          {COLORS.map((color) => (
            <Grid item key={color}>
              <ColorBlock
                color={color}
                selected={color === selectedSidebar}
                onClick={() => handleSidebarColor(color)}
              />
            </Grid>
          ))}
        </Grid>

        <Typography variant="h6" mt={4} gutterBottom>
          Top Bar Color
        </Typography>
        <Grid container spacing={1}>
          {COLORS.map((color) => (
            <Grid item key={color}>
              <ColorBlock
                color={color}
                selected={color === selectedAppbar}
                onClick={() => handleAppbarColor(color)}
              />
            </Grid>
          ))}
        </Grid>

        <Box mt={4}>
          <Button variant="outlined" color="secondary" onClick={handleReset}>
            Reset to Default
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ThemeSettings;
